angular.module('impactx.deliveryadvice').controller('DeliveryAdviceSupplierCtrl', [
    '$scope',
    'dataGen',
    '$controller',
    '$routeParams',
    DeliveryAdviceSupplierCtrl]);

function DeliveryAdviceSupplierCtrl($scope, dataGen, $controller, $routeParams) {
    angular.extend(this, $controller('DeliveryAdviceCtrl', {$scope: $scope}));
    var pohId = $routeParams.pohid;
    var self = this;
    if ($routeParams.avhid) {
        dataGen.getData($scope, {
            id: pohId,
            avhId: $routeParams.avhid
        }, "/deliveryadvice/viewsupplieravh").then(function () {
            $scope.headerSelection.selectedHeader = $scope.data.headers[0];
            self.updateLabels();
            self.defineButtons();
        })
    }
    else {
        dataGen.getData($scope, {id: pohId}, "/deliveryadvice/viewsupplier").then(function () {
            $scope.headerSelection.selectedHeader = $scope.data.headers[0];
            self.updateLabels();
            self.defineButtons();
        });
    }
}